import * as React from 'react';
import { GeneralDomainNotificationSettings } from './general-domain-notification-settings';
import { NotificationAutomationSettings } from './notification-automation-settings';
export var DomainNotificationSettings = function DomainNotificationSettings(props) {
  var showGeneralSettingsWell = props.showGeneralSettingsWell,
    showNotificationAutomationWell = props.showNotificationAutomationWell,
    showInternalEditorAccessFields = props.showInternalEditorAccessFields,
    fetchCustomMacroFields = props.fetchCustomMacroFields,
    domain = props.domain,
    loading = props.loading,
    getAppContainer = props.getAppContainer,
    onEditorSubmit = props.onEditorSubmit,
    wellStyle = props.wellStyle;
  function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, showGeneralSettingsWell && /*#__PURE__*/React.createElement(GeneralDomainNotificationSettings, {
      title: "General Settings",
      domain: domain,
      hideFooter: true,
      loading: loading,
      showInternalEditorAccessFields: !!showInternalEditorAccessFields,
      fetchCustomMacroFields: fetchCustomMacroFields,
      getAppContainer: getAppContainer,
      onSubmit: onEditorSubmit,
      wellStyle: wellStyle
    }), showNotificationAutomationWell && /*#__PURE__*/React.createElement(NotificationAutomationSettings, {
      domain: domain,
      loading: loading,
      hideFooter: true,
      showInternalEditorAccessFields: !!showInternalEditorAccessFields,
      getAppContainer: getAppContainer,
      onEditorSubmit: onEditorSubmit,
      wellStyle: wellStyle
    }));
  }
  return render();
};
export default DomainNotificationSettings;